export function Section({ children, className = "", id, ...rest }) {
  return (
    <section id={id} className={`relative py-24 lg:py-32 ${className}`} {...rest}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">{children}</div>
    </section>
  );
}

export function Overline({ children, className = "" }) {
  return <div className={`overline text-[#C8A96A] ${className}`}>{children}</div>;
}

export function SectionHeading({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <Overline>{eyebrow}</Overline>}
      <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#0B1F3A]">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-6 text-[15px] leading-relaxed text-[#0B1F3A]/70 max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  );
}
